module.exports = __webpack_public_path__ + "media/images/icon-contents-59886a80d58935352d1551ef5ff8c62c.svg";